import { Color } from "@visactor/vutils";

export function colorEqual(color1, color2) {
    const c1 = Color.parseColorString(color1), c2 = Color.parseColorString(color2);
    return !(!c1 || !c2) && (c1.r === c2.r && c1.g === c2.g && c1.b === c2.b && c1.opacity === c2.opacity);
}

export var ColorType;

!function(ColorType) {
    ColorType[ColorType.Color255 = 0] = "Color255", ColorType[ColorType.Color1 = 1] = "Color1";
}(ColorType || (ColorType = {}));

export class ColorStore {
    static Get(str, size = ColorType.Color1, arr = [ 0, 0, 0, 1 ]) {
        if (size === ColorType.Color1) {
            const color = ColorStore.store1[str];
            if (color) return arr[0] = color[0], arr[1] = color[1], arr[2] = color[2], arr[3] = color[3], 
            arr;
            const c = Color.parseColorString(str);
            if (c) {
                const data = [ c.r / 255, c.g / 255, c.b / 255, c.opacity ];
                ColorStore.store1[str] = data, ColorStore.store255[str] = [ c.r, c.g, c.b, c.opacity ], 
                arr[0] = data[0], arr[1] = data[1], arr[2] = data[2], arr[3] = data[3];
            }
            return arr;
        }
        const color = ColorStore.store255[str];
        if (color) return arr[0] = color[0], arr[1] = color[1], arr[2] = color[2], arr[3] = color[3], 
        arr;
        const c = Color.parseColorString(str);
        return c && (ColorStore.store1[str] = [ c.r / 255, c.g / 255, c.b / 255, c.opacity ], 
        ColorStore.store255[str] = [ c.r, c.g, c.b, c.opacity ], arr[0] = c.r, arr[1] = c.g, 
        arr[2] = c.b, arr[3] = c.opacity), arr;
    }
    static Set(str, size, arr) {
        if (size === ColorType.Color1) {
            if (ColorStore.store1[str]) return;
            ColorStore.store1[str] = arr, ColorStore.store255[str] = [ Math.floor(255 * arr[0]), Math.floor(255 * arr[1]), Math.floor(255 * arr[2]), Math.floor(255 * arr[3]) ];
        } else {
            if (ColorStore.store255[str]) return;
            ColorStore.store255[str] = arr, ColorStore.store1[str] = [ arr[0] / 255, arr[1] / 255, arr[2] / 255, arr[3] ];
        }
    }
}

ColorStore.store255 = {}, ColorStore.store1 = {};
//# sourceMappingURL=store.js.map